

























































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import { storeChecklistAnestesi } from "@/store/modules/ChecklistPersiapanAnestesiStore";
import ChecklistAnestesiSvc from "@/services/ChecklistPersiapanAnestesi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { storeDokter } from "@/store/modules/dokter";
import { storePerawat } from "@/store/modules/perawat";

interface ChecklistField {
  key: string;
  label: string;
}

interface ChecklistCategory {
  key: string;
  title: string;
  items: ChecklistField[];
}

@Component({
  components: {
    CardModalTtd,
    DokterAutoComplete,
    PerawatAutoComplete
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class ChecklistPersiapanAnestesiPage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isEditing = false;
  editingId: number | null = null;
  expandedId: number | null = null;
  modalTtd = false;
  saving = false;
  formValid = false;
  signRole: "pelaksana" | "supervisi" = "pelaksana";
  signItemId: number | null = null;

  form: any = this.getEmptyForm();

  categoryLabels = [
    { key: "monitoring", label: "A" },
    { key: "gas_medis", label: "B" },
    { key: "mesin", label: "C" },
    { key: "obat", label: "D" },
    { key: "listrik", label: "E" },
    { key: "airway", label: "F" },
    { key: "lain_lain", label: "G" },
  ];

  checklistCategories: ChecklistCategory[] = [
    {
      key: "monitoring",
      title: "A. Pemantauan / Monitoring",
      items: [
        { key: "mon_kabel_ekg", label: "Kabel EKG monitor standby berfungsi baik (bila diperlukan)" },
        { key: "mon_elektroda", label: "Elektroda tersedia cukup (bila diperlukan)" },
        { key: "mon_kabel_nibp", label: "Kabel NIBP terhubung & berfungsi" },
        { key: "mon_kabel_spo2", label: "Kabel SpO\u2082 terhubung & berfungsi" },
        { key: "mon_kapnograf", label: "Kapnograf terhubung & berfungsi" },
        { key: "mon_kabel_suhu", label: "Kabel pemantau suhu berfungsi (bila diperlukan)" },
      ]
    },
    {
      key: "gas_medis",
      title: "B. Gas Medis",
      items: [
        { key: "gas_indikator_sentral", label: "Indikator sentral gas medis menyala hijau" },
        { key: "gas_selang_terhubung", label: "Selang gas mesin terhubung sumber gas benar" },
        { key: "gas_flowmeter_o2", label: "Flowmeter O\u2082 berfungsi baik" },
        { key: "gas_flowmeter_n2o", label: "Flowmeter N\u2082O berfungsi baik" },
        { key: "gas_flowmeter_air", label: "Flowmeter Air berfungsi baik" },
        { key: "gas_suction_pump", label: "Suction pump berfungsi baik" },
      ]
    },
    {
      key: "mesin",
      title: "C. Mesin Anestesi",
      items: [
        { key: "mesin_power_on", label: "Power mesin posisi ON" },
        { key: "mesin_self_calibration", label: "Self calibration" },
        { key: "mesin_circuit_ok", label: "Circuit tidak bocor, berfungsi baik" },
        { key: "mesin_zat_volatil", label: "Zat Volatil terisi cukup" },
        { key: "mesin_absorber_co2", label: "Absorber CO\u2082 kondisi baik" },
      ]
    },
    {
      key: "obat",
      title: "D. Obat-obatan",
      items: [
        { key: "obat_sedatif", label: "Sedatif (Midazolam / Propofol / Ketamin)" },
        { key: "obat_musculorelaksan", label: "Musculorelaksan" },
        { key: "obat_sulfas_atropin", label: "Sulfas Atropin" },
        { key: "obat_aminophilin", label: "Aminophilin" },
        { key: "obat_kortikosteroid", label: "Kortikosteroid" },
        { key: "obat_efedrin", label: "Efedrin" },
        { key: "obat_epinefrin", label: "Epinefrin" },
        { key: "obat_opioid", label: "Opioid" },
      ]
    },
    {
      key: "listrik",
      title: "E. Listrik",
      items: [
        { key: "listrik_mesin_anestesi", label: "Mesin anestesi terhubung listrik, indikator menyala" },
        { key: "listrik_layar_monitor", label: "Layar pemantauan terhubung listrik, indikator menyala" },
        { key: "listrik_syringe_pump", label: "Syringe pump berfungsi, siap pakai (bila diperlukan)" },
        { key: "listrik_defibrilator", label: "Defibrilator berfungsi, siap pakai (bila diperlukan)" },
      ]
    },
    {
      key: "airway",
      title: "F. Manajemen Jalan Nafas",
      items: [
        { key: "airway_sungkup_muka", label: "Sungkup muka berbagai ukuran siap" },
        { key: "airway_opa", label: "OPA berbagai ukuran siap" },
        { key: "airway_laringoskop", label: "Laringoskop & blade berbagai ukuran berfungsi" },
        { key: "airway_ett_lma", label: "ETT / LMA berbagai ukuran baik" },
        { key: "airway_introduser_stilet", label: "Introduser / Stilet tersedia" },
        { key: "airway_spuit_cuff", label: "Spuit Cuff 10 cc tersedia" },
        { key: "airway_magill_forceps", label: "Magill Forceps tersedia" },
      ]
    },
    {
      key: "lain_lain",
      title: "G. Lain-lain",
      items: [
        { key: "lain_stetoskop", label: "Stetoskop" },
        { key: "lain_suction", label: "Suction, selang dan canul siap pakai" },
        { key: "lain_fiksasi_plaster", label: "Fiksasi plaster" },
      ]
    },
  ];

  async mounted() {
    storeChecklistAnestesi.getByRegister(this.register);
    if (!storeDokter.listAll.length) {
      await storeDokter.act_dokter_all();
    }
    if (!storePerawat.listPerawat.length) {
      await storePerawat.actListPerawatall();
    }
  }

  // ==================== GETTERS ====================

  get stateList() {
    return storeChecklistAnestesi.dataList;
  }

  get stateLoading() {
    return storeChecklistAnestesi.loading;
  }

  get stateUser() {
    return userModule.user;
  }

  get allChecklistFields(): string[] {
    const fields: string[] = [];
    this.checklistCategories.forEach(cat => {
      cat.items.forEach(item => fields.push(item.key));
    });
    return fields;
  }

  get formCompletion() {
    let checked = 0;
    const total = this.allChecklistFields.length;
    this.allChecklistFields.forEach(key => {
      if (this.form[key]) checked++;
    });
    return {
      checked,
      total,
      pct: total > 0 ? Math.round(checked / total * 100) : 0,
    };
  }

  // ==================== PERMISSION CHECKS ====================

  canEdit(item: any) {
    if (this.readOnly) return false;
    return !item.pelaksana_signed_at;
  }

  canDelete(item: any) {
    if (this.readOnly) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        { ditandatangani: item.pelaksana_signed_at, penandaTanganId: item.pelaksana_user_id },
        { ditandatangani: item.supervisi_signed_at, penandaTanganId: item.supervisi_user_id }
      ],
      userModule.user?.id
    );
  }

  canSignPelaksana(item: any) {
    if (this.readOnly) return false;
    return !item.pelaksana_signed_at
      && (!item.pelaksana_user_id || item.pelaksana_user_id == this.stateUser.id);
  }

  canSignSupervisi(item: any) {
    if (this.readOnly) return false;
    return item.pelaksana_signed_at && !item.supervisi_signed_at
      && (!item.supervisi_user_id || item.supervisi_user_id == this.stateUser.id);
  }

  // ==================== CATEGORY HELPERS ====================

  getCatChecked(item: any, catKey: string): number {
    return item.category_completion && item.category_completion[catKey]
      ? item.category_completion[catKey].checked : 0;
  }

  getCatTotal(item: any, catKey: string): number {
    return item.category_completion && item.category_completion[catKey]
      ? item.category_completion[catKey].total : 0;
  }

  getCatColor(item: any, catKey: string): string {
    if (!item.category_completion || !item.category_completion[catKey]) return "grey";
    return item.category_completion[catKey].complete ? "green" : "orange";
  }

  getFormCatChecked(catKey: string): number {
    const cat = this.checklistCategories.find(c => c.key === catKey);
    if (!cat) return 0;
    return cat.items.filter(f => this.form[f.key]).length;
  }

  getFormCatTotal(catKey: string): number {
    const cat = this.checklistCategories.find(c => c.key === catKey);
    return cat ? cat.items.length : 0;
  }

  getFormCatComplete(catKey: string): boolean {
    return this.getFormCatChecked(catKey) === this.getFormCatTotal(catKey);
  }

  checkAllCategory(cat: ChecklistCategory, value: boolean) {
    cat.items.forEach(field => {
      this.$set(this.form, field.key, value);
    });
  }

  // ==================== FORM HELPERS ====================

  getEmptyForm() {
    const form: any = {
      register_id: null,
      pasien_rm: null,
      no_kamar_operasi: "",
      tanggal: localISODate(),
      merk_mesin_anestesi: "",
      laporan_operasi_id: null,
      pelaksana_user_id: null,
      pelaksana_obj: null,
      supervisi_user_id: null,
      supervisi_obj: null,
    };

    const allFields = [
      "mon_kabel_ekg", "mon_elektroda", "mon_kabel_nibp",
      "mon_kabel_spo2", "mon_kapnograf", "mon_kabel_suhu",
      "gas_indikator_sentral", "gas_selang_terhubung",
      "gas_flowmeter_o2", "gas_flowmeter_n2o",
      "gas_flowmeter_air", "gas_suction_pump",
      "mesin_power_on", "mesin_self_calibration",
      "mesin_circuit_ok", "mesin_zat_volatil", "mesin_absorber_co2",
      "obat_sedatif", "obat_musculorelaksan", "obat_sulfas_atropin",
      "obat_aminophilin", "obat_kortikosteroid", "obat_efedrin",
      "obat_epinefrin", "obat_opioid",
      "listrik_mesin_anestesi", "listrik_layar_monitor",
      "listrik_syringe_pump", "listrik_defibrilator",
      "airway_sungkup_muka", "airway_opa", "airway_laringoskop",
      "airway_ett_lma", "airway_introduser_stilet",
      "airway_spuit_cuff", "airway_magill_forceps",
      "lain_stetoskop", "lain_suction", "lain_fiksasi_plaster",
    ];

    allFields.forEach(f => { form[f] = false; });
    return form;
  }

  startCreate() {
    this.form = this.getEmptyForm();
    this.form.register_id = this.register;
    this.form.pasien_rm = this.rm;
    this.editingId = null;
    this.isEditing = true;
  }

  startEdit(item: any) {
    this.form = {
      ...item,
      pelaksana_obj: item.pelaksana_user_id ? { id: item.pelaksana_user_id, nama: item.pelaksana_nama } : null,
      supervisi_obj: item.supervisi_user_id ? { id: item.supervisi_user_id, nama: item.supervisi_nama } : null,
    };
    this.editingId = item.id;
    this.isEditing = true;
  }

  setPelaksana(perawat: any) {
    if (perawat) {
      this.form.pelaksana_user_id = perawat.id;
      this.form.pelaksana_obj = perawat;
    }
  }

  setSupervisi(dokter: any) {
    if (dokter) {
      this.form.supervisi_user_id = dokter.id;
      this.form.supervisi_obj = dokter;
    }
  }

  cancelForm() {
    this.isEditing = false;
    this.editingId = null;
  }

  async simpan() {
    const formRef = this.$refs.formRef as any;
    if (formRef && !formRef.validate()) return;

    this.saving = true;

    try {
      if (this.editingId) {
        await ChecklistAnestesiSvc.update(this.editingId, this.form);
        appModule.sendSuccessNotice("Checklist berhasil diperbarui");
      } else {
        await ChecklistAnestesiSvc.create(this.form);
        appModule.sendSuccessNotice("Checklist berhasil disimpan");
      }

      this.isEditing = false;
      this.editingId = null;
      storeChecklistAnestesi.getByRegister(this.register);
    } catch {
      // error handled by service
    }

    this.saving = false;
  }

  async remove(item: any) {
    if (!this.canDelete(item)) return;
    if (!confirm("Hapus checklist ini?")) return;

    try {
      await ChecklistAnestesiSvc.destroy(item.id);
      appModule.sendSuccessNotice("Checklist berhasil dihapus");
      storeChecklistAnestesi.getByRegister(this.register);
    } catch {
      // error handled by service
    }
  }

  toggleExpand(id: number) {
    this.expandedId = this.expandedId === id ? null : id;
  }

  cetakPdf(item: any) {
    ChecklistAnestesiSvc.print(item.id);
  }

  // ==================== TTD ====================

  openTtd(role: "pelaksana" | "supervisi", item: any) {
    this.signRole = role;
    this.signItemId = item.id;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signItemId) return;
    this.modalTtd = false;

    try {
      if (this.signRole === "pelaksana") {
        await ChecklistAnestesiSvc.signPelaksana(this.signItemId, { password });
        appModule.sendSuccessNotice("Berhasil TTD Pelaksana");
      } else {
        await ChecklistAnestesiSvc.signSupervisi(this.signItemId, { password });
        appModule.sendSuccessNotice("Berhasil TTD Supervisi");
      }

      storeChecklistAnestesi.getByRegister(this.register);
    } catch {
      // error handled by service
    }
  }

  // ==================== FORMATTERS ====================

  formatDate(val: string) {
    if (!val) return "-";
    const d = new Date(val);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" });
  }

  formatDateTime(val: string) {
    if (!val) return "-";
    const d = new Date(val);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" })
      + " " + d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
  }
}
